import { userService } from '../_services'
import { router } from '../_helpers'

const user = JSON.parse(localStorage.getItem('user'))

const initialState = user ? { status: { loggedIn: true }, user } : { status: {}, user: null }

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    token ({ dispatch, commit }, { clientid, secret }) {
      return new Promise((resolve, reject) => {
        userService.logout()
        // Do something here... lets say, a http call using vue-resource
        userService.token(clientid, secret).then(user => {
          commit('loginSuccess', user)
          resolve(user)
        }, error => {
          commit('loginFailure', error)
          reject(error)
        })
      })
    }
  },
  mutations: {
    loginRequest (state, user) {
      state.status = { loggingIn: true }
      state.user = user
    },
    loginSuccess (state, user) {
      state.status = { loggedIn: true }
      state.user = user
    },
    logoutSuccess (state, user) {
      state.status = { loggedIn: false }
      state.user = null
    },
    loginFailure (state, user) {
      state.status = { loggedIn: false }
      state.user = null
    }

  }
}
